<template>
  <div>
    <div class="box-config">
        <div class="box-config__numberofbox">
          <input-label :text="$t('boxConfig.numberOfBoxQuestion')"></input-label>
          <input-selector v-model="boxOption" :options="boxesOptions"/>
        </div>
        <next-transition :visible="boxOption === 1">
          <input-label :text="$t('boxConfig.numberOfBoxesQuestion')"></input-label>
          <box-list v-model="boxCategory"/>
        </next-transition>
        <next-transition :visible="boxOption === 0">
          <input-label :text="$t('boxConfig.numberOfRoomQuestion')"></input-label>
          <input-number
            v-model="nbRoom"
            :height="50"
            :width="150"
            :min="1"
            :step="1"
            @change="onNbRoomChange"/>
          <input-label :text="$t('boxConfig.numberOfPersonQuestion')"></input-label>
          <input-number
            v-model="nbPerson"
            :height="50"
            :width="150"
            :min="1"
            :step="1"
            @change="onNbPersonChange"/>
          <input-label :text="$t('boxConfig.chooseCorrespondingPack')" ></input-label>
          <input-selector v-model="packOptionSync"
                          :options="packOptions"
                          button-class="housing-type__button">
              <template v-slot:default="slotProps">
                  <div class="housing-type">
                    <div class="housing-type__title">
                      {{slotProps.option.label}}
                    </div>
                    <div class="housing-type__label">
                      {{slotProps.option.nbBoxes.cartons_std}}
                      {{$t('boxConfig.standardBox')}}
                    </div>
                    <div class="housing-type__label">
                      {{slotProps.option.nbBoxes.cartons_livre}}
                      {{$t('boxConfig.booksBox')}}
                    </div>
                    <div v-if="hasPenderies"
                         class="housing-type__label">
                      {{slotProps.option.nbBoxes.cartons_penderie}}
                      {{$t('boxConfig.clothBox')}}
                    </div>
                  </div>
              </template>
          </input-selector>
        </next-transition>
    </div>
  </div>
</template>

<script>

import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import InputNumber from '@/components/utils/InputNumber.vue';
import BoxList from '@/components/furnitures/BoxList.vue';
import NextTransition from '@/components/utils/NextTransition.vue';


export default {
  name: 'BoxConfig',
  components: {
    NextTransition,
    BoxList,
    InputLabel,
    InputSelector,
    InputNumber,

  },
  data() {
    return {
      boxOption: null,
      packOption: -1,
      nbRoom: 1,
      nbPerson: 1,
      boxCategory: [
        {
          name: this.$t('boxConfig.standardBox'),
          icon: 'cartons_std',
          size: '55x35x30 cm',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 10,
          hide: false,
        },
        {
          name: this.$t('boxConfig.booksBox'),
          icon: 'cartons_livre',
          size: '35x30x30 cm',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 10,
          hide: false,
        },
        {
          name: this.$t('boxConfig.clothBox'),
          icon: 'cartons_penderie',
          size: '60x55x125 cm',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 1,
          hide: false,
        },
      ],
    };
  },
  computed: {
    boxesOptions() {
      return [
        {
          label: this.$t('base.yes'),
          value: 1,
        },
        {
          label: this.$t('boxConfig.dontKnowNumberOfBox'),
          value: 0,
        },
        {
          label: this.$t('boxConfig.noBoxToCarry'),
          value: -1,
        },
      ];
    },
    packOptions() {
      return [
        {
          label: this.$t('boxConfig.unclutteredFlat'),
          value: 0,
          nbBoxes: {
            cartons_std: Math.round(this.nbBoxes.cartons_std / 2 / 10) * 10,
            cartons_penderie: Math.round(this.nbBoxes.cartons_penderie / 2),
            cartons_livre: Math.round(this.nbBoxes.cartons_livre / 2 / 10) * 10,
          },
        },
        {
          label: this.$t('boxConfig.standardFlat'),
          value: 2,
          nbBoxes: {
            cartons_std: this.nbBoxes.cartons_std,
            cartons_penderie: this.nbBoxes.cartons_penderie,
            cartons_livre: this.nbBoxes.cartons_livre,
          },
        },
        {
          label: this.$t('boxConfig.clutteredFlat'),
          value: 1,
          nbBoxes: {
            cartons_std: Math.round(this.nbBoxes.cartons_std * 1.5 / 10) * 10,
            cartons_penderie: Math.round(this.nbBoxes.cartons_penderie * 1.5),
            cartons_livre: Math.round(this.nbBoxes.cartons_livre * 1.5 / 10) * 10,
          },
        },
      ];
    },
    packOptionSync: {
      get() {
        return this.packOption;
      },
      set(value) {
        const selectedOption = this.packOptions.find(p => p.value === value);
        this.$store.commit('furnituresStore/SET_FLAT_TYPE', selectedOption ? selectedOption.label : '');
        if (selectedOption) {
          this.$store.commit('furnituresStore/SET_TOTAL_CARTON', selectedOption.nbBoxes);
        }
        this.packOption = value;
      },
    },
    nbBoxes() {
      return {
        cartons_std: this.nbRoom * 10 + this.nbPerson * 10,
        cartons_livre: this.nbPerson * 10,
        cartons_penderie: this.hasPenderies ? this.nbPerson * 2 : 0,
      };
    },
    totalCarton: {
      get() {
        return this.$store.getters['furnituresStore/totalCarton'];
      },
      set(value) {
        this.$store.commit('furnituresStore/SET_TOTAL_CARTON', value);
      },
    },
    hasPenderies() {
      return this.$store.getters['serviceOfferStore/wardrobes'];
    },
  },
  methods: {
    onNbRoomChange(value) {
      this.nbRoom = value;
      this.packOptionSync = -1;
    },
    onNbPersonChange(value) {
      this.nbPerson = value;
      this.packOptionSync = -1;
    },
    setBoxCategoryValue() {
      this.boxCategory[0].quantity = this.totalCarton.cartons_std;
      this.boxCategory[1].quantity = this.totalCarton.cartons_livre;
      this.boxCategory[2].quantity = this.hasPenderies
        ? this.totalCarton.cartons_penderie
        : 0;
      this.boxCategory[2].hide = !this.hasPenderies;
    },
  },
  mounted() {
    const isBoxNumberKnown = this.$store.getters['furnituresStore/boxNumberKnown'];
    const defaultBoxOption = this.$store.getters['furnituresStore/totalBoxes'] === 0 ? null : 1;
    this.boxOption = isBoxNumberKnown === -1
      ? isBoxNumberKnown
      : defaultBoxOption;
  },
  watch: {
    boxOption(value) {
      this.$store.commit('furnituresStore/SET_BOX_NUMBER_KNOWN', value);
      if (value === -1) {
        this.totalCarton = {
          cartons_std: 0,
          cartons_livre: 0,
          cartons_penderie: 0,
        };
      }
      if (value === -1 || value === 0) {
        this.packOption = -1;
        this.$store.commit('furnituresStore/SET_FLAT_TYPE', '');
      }
      if (value === 1) {
        this.setBoxCategoryValue();
      }
    },
    boxCategory: {
      deep: true,
      handler(categories) {
        this.totalCarton = {
          cartons_std: categories[0].quantity,
          cartons_livre: categories[1].quantity,
          cartons_penderie: categories[2].quantity,
        };
      },
    },
  },
};
</script>

<style scoped lang="scss">
.room__input-number{
  width: 25%;
}

::v-deep{
  .housing-type__button{
    width: calc(100% - 30px);
    @include breakpoint(tablet) {
      width: auto;
      flex-basis: unset;
    }
  }
}
.housing-type {
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 10px 0;

  &__title {
    font-weight: 600;
    padding-bottom: 10px;
    font-size: 16px;
  }

  @include breakpoint(tablet) {
    width: 135px;

    &__title {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__label {
    font-size: 15px;
    font-weight: normal;
  }
}
</style>
